// src/constants/OrderStatusEnum.ts
export const OrderStatus = {
  PENDING: "PENDING",
  DECLINED: "DECLINED",
  RESERVED: "RESERVED",
  COMPLETED: "COMPLETED",
  ERROR: "ERROR",
} as const;

export default OrderStatus;